export enum Status {
  APPROVED = "Approved",
  REJECTED = "Rejected",
  OUTSTANDING = "Outstanding",
  FOR_APPROVAL = "For Approval",
}
